// ActionLog.js — expandable log of every action taken since login, so the
// owner can verify the records written (refinement 2026-09-07). Each entry
// carries the at-uri of the record it wrote (when available) with deep
// links to the record explorers (atproto.at, pdsls.dev).

import React from 'react';

const fmtTime = (iso) => new Date(iso).toLocaleTimeString([], {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

// Record-explorer deep links. The at://-form breaks both explorers
// (atproto.at 404s on the embedded slashes; pdsls renders blank) — the
// DID-path forms below are verified working:
//   atproto.at/<did>/<collection>/<rkey>   (Taproot)
//   pdsls.dev/at/<did>/<collection>/<rkey>
function RecordLinks({ uri }) {
  if (!uri) return null;
  // at://did/collection/rkey -> did/collection/rkey (path form)
  const path = uri.replace(/^at:\/\//, '');

  return (
    <span className="record-links">
      <a
        href={`https://atproto.at/${path}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        atproto.at
      </a>
      <a
        href={`https://pdsls.dev/at/${path}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        pdsls.dev
      </a>
    </span>
  );
}

const ActionLog = ({ actions }) => {
  return (
    <details className="action-log">
      <summary>
        Action log <span className="count">{actions.length}</span>
      </summary>
      {actions.length === 0 ? (
        <p className="muted">No actions yet this session.</p>
      ) : (
        <ul className="action-list">
          {actions.map((a) => (
            <li key={a.id}>
              <time>{fmtTime(a.ts)}</time>{' '}
              <span className="action-label">{a.label}</span>
              <RecordLinks uri={a.uri} />
            </li>
          ))}
        </ul>
      )}
    </details>
  );
};

export default ActionLog;